import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import ScreenShotTable from './ScreenShotTable';
import { Grid, FormControl } from '@mui/material';
import AutoCompleteSelect from 'views/Common/AutoCompleteSelect';
import {
	getCampaignAPIFunctionForClientId,
	getScreenshotsByClientIdCampaignId,
} from 'services/screenshot.service';
import { getRecentCampaigns } from 'services/campaigns.service';
import ScreenShotDialog from './ScreenshotDialog';

const PREFIX = 'ScreenShot';

const classes = {
    formControl: `${PREFIX}-formControl`,
    goBtn: `${PREFIX}-goBtn`,
    gridcontent: `${PREFIX}-gridcontent`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.formControl}`]: {
		width: '100%',
	},

    [`& .${classes.goBtn}`]: {
		marginTop: '20px',
	},

    [`& .${classes.gridcontent}`]: {
		margin: theme.spacing(2),
	}
}));

const ScreenShot = () => {

	const userDtails = localStorage.getItem('userDetails');
	const parsedUserDetails = userDtails
		? JSON.parse(userDtails)
		: { id: 1, username: 'root' };
	const [showScreenShotModal, setShowScreenShotModal] = useState(false);
	const [advertisementId, setAdvertisementId] = useState(0);
	const [campaignId, setCampaignId] = useState(0);
	const [clientId, setClientId] = useState(0);
	const [campaignName, setCampaignName] = useState(null);
	const [screenshotList, setScreenshotList] = useState([]);

	useEffect(() => {
		setClientId(parsedUserDetails?.data?.clientId);
	}, [parsedUserDetails]);

	const handleCloseModal = () => {
		setShowScreenShotModal(false);
	};

	const handleCampaignNameChange = async (event: any) => {
		if (event.target.value) {
			setCampaignName(event.target.value);
			const response: any = await getScreenshotsByClientIdCampaignId(
				clientId,
				event.target.value.id,
			);
			setScreenshotList(response);
		}
	};

	const showScreenshots = async (ss: any) => {
		setShowScreenShotModal(true);
		setAdvertisementId(ss.advertisementId);
		setCampaignId(ss.campaignId);
	};

	return (
        <Root className="m-3">
			<Grid container spacing={2} style={{padding:"15px"}}>
				<Grid item xs={12}>
					<FormControl variant="outlined" className={classes.formControl}>
						<AutoCompleteSelect
							name="campaign"
							label="Campaign Name"
							handleOnChange={handleCampaignNameChange}
							apiFunction={getCampaignAPIFunctionForClientId(clientId)}
							focusApiFunction={getRecentCampaigns()}
							selectedProperty="campaignName"
							value={campaignName}
							isDisabled={false}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={12}>
					<ScreenShotTable
						screenshotList={screenshotList}
						clientId={clientId}
						showScreenshots={showScreenshots}
					/>
					<ScreenShotDialog
						showScreenShotModal={showScreenShotModal}
						handleCloseModal={handleCloseModal}
						advertisementId={advertisementId}
						campaignId={campaignId}
						clientId={clientId}
					/>
				</Grid>
			</Grid>
		</Root>
    );
};

export default ScreenShot;
